import styled from "styled-components";
import { Modal } from "@mui/material";

import { Cross } from "@/assets/icons";
import { breakpoints } from "@/styles/breakpoints";

export const StyledModalFullPage = styled(Modal)`
    position: fixed;
    top: 0;
    border: 0;
    margin: 0;
    border-radius: 0;
    left: 0;
    z-index: 1300;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 20px;
    background-color: var(--color-grey-400);
`;

export const ModalFullPageHeader = styled.div`
    display: flex;
    align-items: center;
`;

export const ModalFullPageTitle = styled.span`
    font-size: var(--size-16);
    line-height: 24px;
    color: var(--color-primary);

    @media ${breakpoints.xs} {
        text-transform: none;
    }
`;

export const StyledCross = styled(Cross)`
    width: 24px;
    height: 24px;

    path {
        fill: var(--color-secondary);
    }
`;
